import React from 'react'
import { Box, Container, Typography, Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import Background from '../components/Background'

export default function PrivacyPolicy() {
  return (
    <Box component="main" sx={{ bgcolor: '#000', color: '#fff', minHeight: '100vh', position: 'relative' }}>
      <Background />
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1, py: 8 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Privacy Policy
        </Typography>
        <Typography variant="subtitle1" gutterBottom sx={{ color: '#ccc' }}>
          Effective Date: July 2025
        </Typography>

        {/* Section 1 */}
        <Typography variant="h6" gutterBottom>1. No Data Collection</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          Scout does <strong>not</strong> collect, transmit, or store any personal data by default. All operations are performed locally on your device. We do not track usage, scan files, or store cloud backups unless you explicitly enable such features.
        </Typography>

        {/* Section 2 */}
        <Typography variant="h6" gutterBottom>2. Information We Never Collect</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          • Names, emails, phone numbers<br />
          • Files or content stored on your machine<br />
          • User behavior, analytics, or telemetry<br />
          • Location or network identifiers<br />
        </Typography>

        {/* Section 3 */}
        <Typography variant="h6" gutterBottom>3. Optional Internet Access</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          You may enable certain agents to use the internet or connect to cloud services. When enabled, this functionality falls outside of Scout’s local-only guarantees. Use caution and review the terms of any external services you connect to.
        </Typography>

        {/* Section 4 */}
        <Typography variant="h6" gutterBottom>4. Developer Responsibilities</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          Developers must adhere to Scout’s API and SDK policies. Agents must not transmit user data without explicit opt-in consent, and must comply with all applicable privacy regulations and technical safeguards.
        </Typography>

        {/* Section 5 */}
        <Typography variant="h6" gutterBottom>5. Data Ownership</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          All data remains on your device and under your control. Scout does not retain or mirror your content. You are free to remove, export, or delete data at any time, without needing to request access.
        </Typography>

        {/* Section 6 */}
        <Typography variant="h6" gutterBottom>6. Third-Party Tools</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          Scout does not embed advertising, analytics trackers, or telemetry systems. If you voluntarily install or authorize third-party services via an agent, their policies apply independently of Scout.
        </Typography>

        {/* Section 7 */}
        <Typography variant="h6" gutterBottom>7. Children’s Privacy</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          The Service is not designed for or intended to be used by individuals under the age of 13. We do not knowingly collect or process data from minors.
        </Typography>

        {/* Section 8 */}
        <Typography variant="h6" gutterBottom>8. Security</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          Scout executes agents in sandboxed environments with user-controlled permission scopes. We follow best practices for secure code execution, though ultimate responsibility lies with the developer of each agent.
        </Typography>

        {/* Section 9 */}
        <Typography variant="h6" gutterBottom>9. Changes to this Policy</Typography>
        <Typography paragraph sx={{ color: '#ccc', lineHeight: 1.6 }}>
          This Privacy Policy may be revised from time to time. Material changes will be communicated via product updates or this page. Continued use of Scout indicates acceptance of the revised terms.
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Link component={RouterLink} to="/" variant="body2" sx={{ color: '#467EE5' }}>
            ← Back to Home
          </Link>
        </Box>
      </Container>
    </Box>
  )
}
